<template>
<div class="chapter">
<div class="inner_page">
<div class="box1">
<p class="center" style="line-height: 1em;"><span class="big"><strong>THE</strong></span></p>
<p class="center"><img alt="" src="OEBPS/images/tp_everuthing.jpg"/><br/><span class="big2"><strong>PARENT’S GUIDE TO</strong></span><br/><span class="big3"><strong>EATING DISORDERS</strong></span></p>
<p class="extract">Dear Reader,</p>
<p class="extract">Eating disorders have affected my life in more ways than I ever would have imagined. There was a time when the only thing I knew about eating disorders was what I had read. That was before. Before eating disorders affected people I love and almost took my life.</p>
<p class="indent">Recovery is possible. The journey through an eating disorder may well be the most difficult struggle one can encounter. The only path more difficult may be if one’s own child is facing an eating disorder. It hurts to watch one’s child literally unable to face eating. The emotional roller coaster is difficult to describe and ranges from fear and frustration to heartache and even anger.</p>
<p class="indent">My message to both you and your child you love is twofold. First, don’t give up; never stop fighting. Second, the best you can do is enough, and there is no room for blame on this battlefield. Love, love, love.</p>
<p class="indent">Wishing you joy, comfort, and peace,</p>
<p class="extract"><img alt="" src="OEBPS/images/1-1.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?05328966